import React, { useState } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import Carousel from 'react-bootstrap/Carousel';
import VideoEmbed from '../components/VideoEmbed';
import Modal from 'react-bootstrap/Modal';

function HeroModal() {
	const [modalShow, setModalShow] = useState(false);
	const [url, setUrl] = useState("");

	const handleModalClose = () => setModalShow(false);
	const handleModalShow = url => {
		setModalShow(true);
		setUrl(url);
	}

	return (
		<div className="d-flex mt-1 mb-1">
			<div className="videoContainer">
				<div className="videoItem">
					<a target="_blank" onClick={() => {handleModalShow('https://youtu.be/hDvaAIAAnsg')}} >
						<div>
							<img src="/img/Thumbnail-video-1.jpeg" alt="" />
						</div>
						<p className="videoDescription">ChartHop Engineering Video</p>
					</a>
				</div>
				<div className="videoItem">
					<a target="_blank" onClick={() => {handleModalShow('https://youtu.be/XSWWabNPNik')}} > 
						<div>
							<img src="/img/Thumbnail-video-2.jpeg"  alt="" />
						</div>
						<p className="videoDescription">Why do you think ChartHop is going to go big?</p>
					</a>
				</div>
				<div className="videoItem">
					<a target="_blank" onClick={() => {handleModalShow('https://youtu.be/ldt2a95kv_Q')}} >
						<div>
							<img src="/img/Thumbnail-video-3.jpeg"  alt="" />
						</div>
						<p className="videoDescription">Inside ChartHop</p>
					</a>
				</div>
			</div>

			<Modal size="sm" show={modalShow} onHide={handleModalClose} dialogClassName="videoModal" centered>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>
					<VideoEmbed url={url} autoplay={true}/>
				</Modal.Body>
			</Modal>
		</div>
	);
}

function TestimonialsCareers(props) {

	const json = props.data.allTestimonialsCareersJson.edges
	//tesimonials.json and testimonialContent must have people in the same order.
	const testimonialContent = [
		//Savannah
		<p className="testimonialText">A big strength of ChartHop is that we are hiring people who are as talented as they are kind and engaged.</p>,
		//Yona
		<p className="testimonialText">I feel safe here. I don't need to explain myself or what I'm about. I am auto-accepted.</p>,
		//Ai-Mei
		<p className="testimonialText">The people and product are amazing. As a recruiter, I need to believe in the company I am pitching, but to work in such a diverse, transparent, and inclusive environment is just another cherry on top!</p>,
		//Kyle
		<p className="testimonialText">I'm passionate about what we do and can feel the same sentiment across the org. We have an incredibly talented team that I'm able to learn from on a daily basis.</p>,
		//Jeconiah
		<p className="testimonialText">As a team, we're building the groundwork for having a real impact in the HR tech space. I appreciate the level of transparency from leadership in sharing our roadmap as well as acknowledging the challenges we face in these times.</p>,
		//Joe
		<p className="testimonialText">Working at ChartHop has allowed me to work with professionals who challenge me everyday to help create a platform that will improve transparency in all types of organizations. I love the fact that my contribution today will positively impact strategies of how companies hire and compensate their employees now and in the future.</p>
	]

	return (
		<div className={"Testimonials-careers " + (props.bgGrey ? "bgGrey" : " ")}>
			<section className={"customer testimonial-container sectionSpacing " + (props.bgGrey ? " bgGrey" : " bgWhite")}>
				<div className="container" >
					<h2 className="text-center testimonials-title">Hear from our staff:</h2>
					<Carousel controls={true}>
						{json.map((edge, index) => (
							<Carousel.Item key={edge.node.name} >
								<div className="carouselWrapper row" >
									<div className="carouselContent">
										<img src={'/home/quote.svg'} alt="" className="pb-1 pb-sm-2" />
										{testimonialContent[index]}
										<div className="div-display">
											<div className="testimonialAuthorContain" >
												<div className="carImageContain mobileHeadshot  text-center">
													<img src={edge.node.image} alt="Author" />
												</div>
												<div className="p-direction">
													<p className="testimonialAuthor mt-3">{edge.node.name} | {edge.node.title}</p>
												</div>
											</div>
										</div>
									</div>
									<div className="carImageContain desktopHeadshot text-sm-center text-md-center">
										<img src={edge.node.image} alt="Author" />
									</div>
								</div>
							</Carousel.Item>
						))}
					</Carousel>
					<HeroModal />
				</div>
			</section>
		</div>
	);
}



export default function TestimonialsQueried(props) {
	return (
		<StaticQuery
			query={graphql`
		query {
			allTestimonialsCareersJson {
		    edges {
		      node {
		        id
		        name
		        title
		        image
		      }
		    }
		  }
		}
      `}
			render={data => <TestimonialsCareers data={data} {...props} />}
		/>
	)
}